import React from 'react';
import classNames from 'classnames';
import EnterpriseMembersProvider from 'providers/EnterpriseMembers';
import { Enterprise, EnterpriseBusinessUnit } from 'models/Enterprises';
import TeamFilters from 'router/subrouters/Dash/subrouters/private/subrouters/Enterprise/pages/Team/components/TeamFilters';
import TeamMembersTable from 'router/subrouters/Dash/subrouters/private/subrouters/Enterprise/pages/Team/components/TeamMembersTable';

import './EnterpiseTeam.styles.scss';

type EnterpiseTeamProps = {
  className?: string;
  enterprise: Partial<Enterprise>;
  refetchFlag?: boolean;
  withNavigation?: boolean;
  isRWC?: boolean;
  updateBusinessUnits: (
    updatedBusinessUnits: EnterpriseBusinessUnit[],
    shouldRefetch?: boolean,
  ) => void;
};

const EnterpiseTeam: React.FC<EnterpiseTeamProps> = (props) => {
  const {
    className,
    enterprise,
    refetchFlag,
    withNavigation = true,
    isRWC = false,
    updateBusinessUnits,
  } = props;

  const classes = classNames('enterpise-team', className);

  return (
    <div className={classes}>
      <EnterpriseMembersProvider
        enterprise={enterprise}
        refetchFlag={refetchFlag}
        updateBusinessUnits={updateBusinessUnits}
      >
        <TeamFilters withNavigation={withNavigation} />
        <TeamMembersTable isRWC={isRWC} />
      </EnterpriseMembersProvider>
    </div>
  );
};

export default EnterpiseTeam;
